import React from 'react';
import {
  Button,
  Grid,
  FormControl,
  TextField,
  CircularProgress,
} from '@mui/material';
import moment from 'moment/moment';
import 'moment/locale/es';
import { currency } from '../../utils/utils';
import useHook from './useHook';
import styles from './styles.module.scss';

const ContenedorEnvios = () => {
  const {
    cp,
    reduxCp,
    loading,
    shippings,
    diasDePreparacion,
    handleChange,
    handleClean,
  } = useHook();

  return (<>
    <div className={styles.box} style={{ maxWidth: "600px" }}>
      {(!cp || cp.length < 4)
        ?
        <div className={styles.container}>
          <p><b><u>Ingresá tu código postal para calcular tu envío</u></b></p><br />
          <div className={styles.container} style={{ maxWidth: "220px" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <FormControl fullWidth>
                  <TextField
                    required
                    fullWidth
                    id="cp"
                    label="Código postal"
                    variant="outlined"
                    type="tel"
                    value={cp}
                    autoComplete="current-email"
                    color="secondary"
                    onChange={(e) => handleChange(e.target.value)}
                    InputProps={{
                      style: {
                        borderRadius: "100px",
                        background: "#fff",
                        padding: "0 6px"
                      },
                    }}
                    inputProps={{ maxLength: 4 }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </div>
        :
        <div className={styles.container}>
          <p><b><u>Envíos disponibles para {reduxCp}</u></b></p><br />
          {loading &&
                        <CircularProgress size="30px" />
          }
          {!loading && shippings?.length > 0 &&
                        shippings.map((shipping: any, index: number) => (
                          <div className={styles.item} key={index}>
                            <div className={styles.flexLine}>
                              <p>{shipping?.ship_to?.address?.address_line ? `Lo retirás en ${shipping?.ship_to?.address?.address_line}` : 'Lo recibís en tu domicilio'}</p>
                              <p><b>${currency(shipping?.tax_price)}</b></p>
                            </div>
                            {moment(shipping?.minimum_delivery).add(diasDePreparacion, 'days').isSame(moment(shipping?.maximum_delivery).add(diasDePreparacion, 'days'), 'day') ?
                              <em>Está listo el {moment(shipping?.minimum_delivery).add(diasDePreparacion, 'days').format('dddd D [de] MMMM')}</em>
                              :
                              <em>Está listo entre el {moment(shipping?.minimum_delivery).add(diasDePreparacion, 'days').format('dddd D [de] MMMM')} y el {moment(shipping?.maximum_delivery).add(diasDePreparacion, 'days').format('D [de] MMMM')}</em>

                            }
                          </div>
                        ))
          }
          <br /><br />
          <Button
            variant='text'
            color="secondary"
            onClick={handleClean}
          ><p><u>Cambiar código postal</u></p></Button>
        </div>
      }
    </div>
  </>);
};

export default ContenedorEnvios;
/* https://shipnow.docs.apiary.io/ */
